let alertAudio = null;

const BsAlertSrc = `${process.env.PUBLIC_URL}/bed_status_tran_in_alert.mp3`;

function initBsAlereAudio() {
  alertAudio = new Audio(`${process.env.PUBLIC_URL}/bed_status_tran_in_alert.mp3`);
}

function getAudionSingleton() {
  return alertAudio;
}

export { initBsAlereAudio, getAudionSingleton, BsAlertSrc };
